module.exports = __webpack_public_path__ + "static/impeccable-wraps-df6fc694cc8292e69eabc6e2c5865ef9.png";